// COMMON UTIL FOR GETTING REDUX ACTION BY TYPE AND PAYLOAD
const getActionObject = (type, payload) => {
  return {
    type,
    payload,
  };
};

export default getActionObject;
